exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".returns_table {\n  border: 1px solid #ccc;\n  border-top: none;\n  overflow: auto; }\n  .returns_table table thead {\n    color: #ffffff;\n    text-transform: uppercase; }\n    .returns_table table thead tr {\n      background-color: slategrey; }\n  .returns_table table tr {\n    border-bottom: 1px solid #ccc; }\n    .returns_table table tr:last-child {\n      border-bottom: none; }\n  .returns_table table input {\n    all: unset; }\n  .returns_table table tbody {\n    color: #141414; }\n  .returns_table .returnsColum {\n    width: 50px; }\n    .returns_table .returnsColum input {\n      width: 50px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create/universe_lite/Analyze/returnsTable/returnsTable.style.scss
// module id = 825
// module chunks = 0